import VerifyAccModal from "components/Modal/VerifyAccModal"
import VerifyNotification from "components/VerifyNotification/VerifyNotification"
import { useUserContext } from "context/UserContext"
import { AnimatePresence, domAnimation, LazyMotion, m } from "framer-motion"
import { getCookie } from "utils/helpers/cookies/getCookie"
import dynamic from "next/dynamic"
import React, { ReactNode, useEffect, useState } from "react"
import useVerificationRequired from "hooks/useVerificationRequired"

const NewNavbar = dynamic(() => import("./NewNavbar"), {
    ssr: false,
    loading() {
        return (
            <div className="z-50 flex h-[70px] bg-white px-5 py-2 shadow-3xl dark:bg-gradient-to-r dark:from-[#212121] dark:via-[#212121] dark:to-[#212121] md:h-[80px] lg:px-20 "></div>
        )
    },
})

const MobileMenu = dynamic(() => import("./MobileMenu"), {
    ssr: false,
})

const FooterMobile = dynamic(
    () => import("components/Layout/FooterMobile/FooterMobile"),
    {
        ssr: false,
        loading: () => {
            return (
                <footer
                    className={`relative flex h-[580px] flex-col overflow-hidden bg-white shadow-[0_0_9px_5px_rgba(0,0,0,0.05)] dark:bg-[#3A2B87] md:hidden`}
                ></footer>
            )
        },
    }
)

interface IProps {
    children: ReactNode
    loading?: boolean
    fixed?: boolean
}

// const ISSERVER = typeof window === "undefined"

const CompanyLayout = ({ children }: IProps) => {
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [showNotification, setShowNotification] = useState<boolean>(false)
    const [verifyCookie, setVerifyCookie] = useState<boolean>(false)
    const { user } = useUserContext()

    // Get verification requirement flags
    const { isVerificationRequired, isUserVerified } = useVerificationRequired()

    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)

    useEffect(() => {
        if (typeof window !== "undefined") {
            const x = getCookie("verifyNotification")
            if (x) {
                setVerifyCookie(true)
            } else {
                setVerifyCookie(false)
            }
        }
    }, [])

    useEffect(() => {
        // Don't show notification if verification is not required by feature flags
        if (!isVerificationRequired) {
            setShowNotification(false)
            return
        }

        if (!user) {
            setShowNotification(false)
        } else if (!verifyCookie && !isUserVerified) {
            setShowNotification(true)
        } else {
            setShowNotification(false)
        }
    }, [user, verifyCookie, isVerificationRequired, isUserVerified])

    return (
        <>
            <NewNavbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />

            <AnimatePresence>
                {isMenuOpen && <MobileMenu setIsMenuOpen={setIsMenuOpen} />}
            </AnimatePresence>

            {!verifyCookie && showNotification && (
                <VerifyNotification
                    setOpenModal={setOpenModal}
                    setShowNotification={setShowNotification}
                    isEmailVerified={user?.verification?.is_email_verified}
                    isPhoneVerified={user?.verification?.is_phone_verified}
                />
            )}

            <VerifyAccModal
                setIsModalOpen={setOpenModal}
                isModalOpen={openModal}
            />
            <LazyMotion features={domAnimation}>
                <m.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.2 }}
                >
                    {children}
                </m.div>
            </LazyMotion>

            {/* <Footer /> */}
            <FooterMobile />
        </>
    )
}

export default CompanyLayout
